<template>
  <div v-if="defect" class="container">
    <div class="row">
      <div class="col-sm-3">
        <span class="item-detail-title">{{ $t('area_report_details.area_name') }}</span>
        <span class="item-detail-text">
          {{ defect.area ? defect.area.name : '-' }}
        </span>
      </div>
      <div class="col-sm-3">
          <span class="item-detail-title">{{ $t('areas.equipment_name') }}</span>
          <span class="item-detail-text">{{ defect.area_equipment.name }}</span>
      </div>
      <div class="col-sm-6">
          <span class="item-detail-title">{{ $t('work_assignment.info') }}</span>
          <span
              v-if="defect.description"
              class="item-detail-text"
          >
          {{ defect.description }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {observationHelper} from '../mixins/ObservationMixin'
import MapContainer from "../map/MapContainer";

export default {
    name: 'WorkAssignmentAreaDefect',
    components: {MapContainer},
    mixins: [timeUtils, observationHelper],
    props: {
        defect: {
            type: Object,
            default: function () {
                return null
            }
        }
    },
    methods: {
    }
}
</script>
<style scoped>
</style>
